<template>
    <div class="Team">
        <menuBox :step="3"></menuBox>
        <div class="team-1">
            <!-- <div class="team-text-1">Meet the Visionaries</div> -->
            <div class="team-text-2">Meet the Visionaries</div>
            <div class="team-text-3"> Get ready to embark on a journey of collaboration with a team that combines passion, expertise, and unwavering dedication to your success.</div>
        </div>
        <div class="team-2">
            <div class="title">Our Dynamic Team</div>
            <div class="team-list">
                <div class="item">
                    <img src="../assets/team-2.png" alt="">
                    <div>I. Leadership Prowess</div>
                    <p>At the helm of EXTEND TECH is a team of visionaries who bring a wealth of experience and expertise to the table. Our leaders, with a proven track record in the tech industry, steer the company towards innovation and success. Their strategic foresight and commitment to excellence set the tone for our dynamic and forward-thinking approach.</p>
                </div>
                <div class="item">
                    <img src="../assets/team-3.png" alt="">
                    <div>II. Tech Enthusiasts</div>
                    <p>Our tech enthusiasts form the backbone of EXTEND TECH. From seasoned software architects to talented developers, our team is united by a passion for pushing technological boundaries. With a relentless pursuit of excellence, they transform ideas into reality, ensuring that our SAAS solutions remain at the forefront of industry standards.</p>
                </div>
                <div class="item">
                    <img src="../assets/team-4.png" alt="">
                    <div>III. Customer-Centric Support</div>
                    <p>Behind every successful implementation is a dedicated support team that puts customers first. Our support professionals are not just troubleshooters; they are partners in your success journey. With a commitment to responsiveness and solution-oriented approaches, our support team ensures that you experience uninterrupted excellence with EXTEND TECH.</p>
                </div>
            </div>
        </div>
        <div class="team-3">
            <img src="../assets/team-1.png" alt="">
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.team-1 {
    height: 500px;
    background: url(../assets/us-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: self-start;
    justify-content: center;

    .team-text-1 {
        font-size: 16px;
        font-weight: 600;
        color: #3DA685;
        padding: 10px 28px;
        background: fade(#3DA685, 30%);
        margin-left: 300px;
    }

    .team-text-2 {
        font-size: 62px;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 13px;
        width: 750px;
        margin-left: 300px;
    }

    .team-text-3 {
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 8px;
        width: 550px;
        margin-left: 300px;
    }
}

.team-2 {
    padding: 120px 300px;

    .title {
        text-align: center;
        font-size: 64px;
        font-weight: 600;
        color: #0F1010;

    }

    .team-list {
        margin-top: 80px;
        display: flex;
        align-items: self-start;
        justify-content: space-between;

        .item {
            width: 400px;

            img {
                width: 400px;
            }

            div {
                font-size: 24px;
                font-weight: 600;
                color: #0F1010;
                margin-top: 30px;
            }

            p {
                font-size: 18px;
                color: #999999;
                margin-top: 30px;
            }
        }
    }
}

.team-3 {
    display: flex;
    align-content: center;
    justify-content: center;
    padding-bottom: 120px;

    img {
        width: 1280px;
    }
}
</style>
